import React from 'react';
import './../../style/css/shared.css';

interface Props {
    isLoading?: boolean;
}

const Loader = (props: Props) => {
    return (
        <div className={'loader' + (!props.isLoading ? ' loader-hidden' : '')}>
            <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
        </div>
    );
};

export default Loader;
